import React, { ReactElement, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { delay } from "helpers/app";

import Container from "@mui/material/Container";

import ClusterManage from "components/cluster/ClusterManage";
import LoadingComponent from "components/shared/loaders/LoadingComponent";

import { getAllClusterNodes } from "redux/handlers/clusterHandler";
import { postServerDetails } from "redux/handlers/serverHandler";

import { useAppDispatch } from "hooks/reduxHook";

const ClusterPage = (): ReactElement => {
 const dispatch = useAppDispatch();
 const params = useParams<{ id: string }>();

 const [loading, setLoading] = useState<boolean>(false);

 const handleGetServerDetails = async () => {
  setLoading(true);
  await dispatch(postServerDetails(Number(params.id)));
  await dispatch(getAllClusterNodes(Number(params.id), ""));
  await delay(3000);
  setLoading(false);
 };

 useEffect(() => {
  params.id && handleGetServerDetails();
 }, [params.id]);

 return (
  <Container maxWidth={false} sx={{ mx: 2, width: "auto" }}>
   {loading ? <LoadingComponent section="cluster" /> : <ClusterManage />}
  </Container>
 );
};

export default ClusterPage;
